module.exports = __webpack_public_path__ + "img/s-hd.a8972c09.jpg";